import { getSizedImageUrl } from '@shopify/theme-images';

export const findAncestor = (el, sel) => {
  let parent = el.parentElement;
  while (!((parent.matches || parent.matchesSelector).call(parent, sel))) {
    parent = parent.parentElement;
  }
  return parent;
};

export const formatMoney = (cents) => {
  const numberFormat = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' });
  const formatted = numberFormat.format(cents / 100);
  return formatted.replace('.00', '');
};

export const getTagValue = (tags, namespace) => {
  const filtered = tags.find((tag) => tag.includes(`${namespace}:`));
  if (filtered) return filtered.replace(`${namespace}:`, '').trim();
  return null;
};

export const getImgSrcsets = (imgsrc) => `${getSizedImageUrl(imgsrc, '640x')} 640w, ${getSizedImageUrl(imgsrc, '768x')} 768w, ${getSizedImageUrl(imgsrc, '1024x')} 1024w, ${getSizedImageUrl(imgsrc, '1366x')} 1366w, ${getSizedImageUrl(imgsrc, '1600x')} 1600w, ${getSizedImageUrl(imgsrc, '1920')} 1920w`;

export const addRecentItemToLocalStorage = (item) => {
  const recentlyViewed = localStorage.getItem('recentlyViewed') ? JSON.parse(localStorage.getItem('recentlyViewed')) : [];
  if (!item.measurements) item.measurements = null;

  const max10 = [item, ...recentlyViewed.filter((recentItem) => recentItem.handle
        !== item.handle).slice(0, 10)];
  if (item.handle) localStorage.setItem('recentlyViewed', JSON.stringify(max10));
};

export const getFurnitureImage = (product, colors, sizing = '1000x') => {
  let html = `https://gmamnyqi87.execute-api.ap-southeast-2.amazonaws.com/production/${sizing}/${product.replace('/', '-').replace(/_/g, '-')}`;
  colors.forEach((color) => {
    if (typeof color.material === 'string') html += `_${color.material.replace(/ /g, '_')}_${color.color.replace(/ /g, '_')}`;
  });
  html += '.png';
  return html;
};

export const getFurnitureSrcset = (product, colors) => {
  const sizes = ['640', '768', '1024', '1366', '1600', '1920'];
  return sizes.map((size) => `${getFurnitureImage(product, colors, `${size}x`)} ${size}w`).join();
};

// compare the values of two objects
export const isEquivalent = (a, b) => {
  const aProps = Object.getOwnPropertyNames(a);
  const bProps = Object.getOwnPropertyNames(b);

  if (aProps.length !== bProps.length) {
    return false;
  }
  for (let i = 0; i < aProps.length; i += 1) {
    const propName = aProps[i];

    if (a[propName] !== b[propName]) {
      return false;
    }
  }
  return true;
};

export const getUniqueLineItemId = (id, properties) => {
  if (Array.isArray(properties)) return `${id}${properties.join()}`;
  if (typeof properties === 'object') return `${id}${Object.keys(properties).map((property) => [property, properties[property]]).join()}`;
  return null;
};
